import { render, staticRenderFns } from "./OneLoanAttribute.vue?vue&type=template&id=20960072&scoped=true"
import script from "./OneLoanAttribute.vue?vue&type=script&lang=js"
export * from "./OneLoanAttribute.vue?vue&type=script&lang=js"
import style0 from "./OneLoanAttribute.vue?vue&type=style&index=0&id=20960072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20960072",
  null
  
)

export default component.exports